/* eslint-disable */
export default {
  start: 'Faire une visite rapide',
  skip: 'Passer',
  next: 'Suivant',
  finish: 'Terminer',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
